
import React, { useState } from 'react';
// TODO : Uncomment when cards product is enabled, was disabled at the request of BM-365
// import { LocationSVG, ProfileCircleSVG, CardsSVG, SummarySVG, MovementsSVG, DeviceSVG, CollectionsSVG, PhoneSVG, PaymentLinksSVG, AccountPositionSVG, TransactionsPositionSVG } from '../../../components';
import { LocationSVG, ProfileCircleSVG, MovementsSVG, DeviceSVG, PhoneSVG, PaymentLinksSVG } from '../../../components';
import { Box, ButtonBase } from '@mui/material';
import { VectorMenuSVG } from '../../../components/svg/VectorMenuSVG';
import enabledPages from '../../../constants/pages/enabledPages';
import { useHistory, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import { EmailSVG } from '../../../components/svg/EmailSVG';
import { RightArrowSVG } from '../../../components/svg/RightArrowSVG';
import { getColor } from '../../../helpers/getColor';
import { palette } from '../../../styles/theme';
import '../../../styles/sass/clients/clientDropMenu.scss';
import '../../../styles/sass/global/components/checker.scss';
import { checkPermissions } from '../../../helpers/PermissionsChecker';

export default function ClientDropMenu ({ data }) {
    // Handlers
    const { t } = useTranslation();
    const [isSubMenuOpen, setIsSubMenuOpen] = useState('');
    const location = useLocation();
    const history = useHistory();
    const { id } = useParams();
    const clientId = parseInt(id);
    const isDetailsVisible = /\bdetails\b/.test(location.pathname);
    const isAddressVisible = /\baddress\b/.test(location.pathname);
    const isEmailVisible = /\bemail\b/.test(location.pathname);
    const isTelephoneVisible = /\bmobile\b/.test(location.pathname);
    const isDeviceVisible = /\bdevice\b/.test(location.pathname);
    const isPaymentLinksVisible = /\bpaymentLinks\b/.test(location.pathname);
    const isPaymentMovementsVisible = /\bpaymentMovements\b/.test(location.pathname);
    const isPaymentLinksPositionVisible = /\bpaymentLinksPosition\b/.test(location.pathname);

    // TODO: Uncomment when cards product is enabled, was disabled at the request of BM-365
    // const isCardsVisible = /\bcard\b/.test(location.pathname);
    // const isSummaryVisible = /\bsummary\b/.test(location.pathname);
    // const isMovementsVisible = /\bmovements\b/.test(location.pathname);
    // const isCollectionsVisible = /\bcollections\b/.test(location.pathname);

    // Tabs

    const toggleSubmenu = (tab) => {
        if (tab !== isSubMenuOpen) {
            setIsSubMenuOpen(tab);
        }
        else {
            setIsSubMenuOpen('');
        }
    };

    const tabsColumn = [
        {
            menu: t('details.title'),
            enabled: checkPermissions('show_clients.sub_details'),
            startIconMenu: isDetailsVisible && !isAddressVisible && !isEmailVisible && !isTelephoneVisible && !isDeviceVisible ? <ProfileCircleSVG customStroke='white' /> : <ProfileCircleSVG />,
            isVisible: isDetailsVisible && !isAddressVisible && !isEmailVisible && !isTelephoneVisible && !isDeviceVisible,
            tabSubMenu: 'details',
            onClick: () => {
                toggleSubmenu('details');
                history.push(`/clients/details/${clientId}`);
            },
            subMenus: [
                {
                    subMenu: t('details.subTitles.address'),
                    tabSubMenu: 'address',
                    isSubMenuVisible: isAddressVisible,
                    startIconSubMenu: isAddressVisible ? <LocationSVG customStroke='white' /> : <LocationSVG />,
                    onClickSubMenu: () => {
                        toggleSubmenu('address');
                        history.push(`/clients/details/address/${clientId}`);
                    }
                },
                {
                    subMenu: t('details.subTitles.email'),
                    tabSubMenu: 'email',
                    isSubMenuVisible: isEmailVisible,
                    startIconSubMenu: isEmailVisible ? <EmailSVG customStroke='white' /> : <EmailSVG />,
                    onClickSubMenu: () => {
                        toggleSubmenu('email');
                        history.push(`/clients/details/email/${clientId}`);
                    }
                },
                {
                    subMenu: t('details.subTitles.telephone'),
                    tabSubMenu: 'telephone',
                    isSubMenuVisible: isTelephoneVisible,
                    startIconSubMenu: isTelephoneVisible ? <PhoneSVG customStroke='white' /> : <PhoneSVG />,
                    onClickSubMenu: () => {
                        toggleSubmenu('telephone');
                        history.push(`/clients/details/mobile/${clientId}`);
                    }
                },
                {
                    subMenu: t('details.subTitles.device'),
                    tabSubMenu: 'device',
                    isSubMenuVisible: isDeviceVisible,
                    enabled: enabledPages.enableDevice,
                    startIconSubMenu: isDeviceVisible ? <DeviceSVG customStroke='white' /> : <DeviceSVG />,
                    onClickSubMenu: () => {
                        toggleSubmenu('device');
                        history.push(`/clients/details/device/${clientId}`);
                    }
                },
            ]
        },
        {
            menu: t('paymentLinks.subtitle'),
            enabled: checkPermissions('show_clients.sub_links'),
            startIconMenu:
            isPaymentLinksPositionVisible &&
            !isPaymentLinksVisible &&
            !isPaymentMovementsVisible
                ? <PaymentLinksSVG customStroke='white' /> : <PaymentLinksSVG />,
            isVisible: isPaymentLinksPositionVisible,
            tabSubMenu: 'paymentLinks',
            onClick: () => {
                toggleSubmenu('paymentLinks');
                history.push(`/clients/paymentLinksPosition/${clientId}`);
            },
            subMenus: [
                {
                    subMenu: t('paymentLinks.title'),
                    tabSubMenu: 'paymentLinks',
                    isSubMenuVisible: isPaymentLinksVisible,
                    startIconSubMenu: isPaymentLinksVisible ? <PaymentLinksSVG customStroke="white" /> : <PaymentLinksSVG />,
                    endIconSubMenu: <RightArrowSVG customStroke= {isPaymentLinksVisible ? 'white' : getColor('secondary', '600')} />,
                    onClickSubMenu: () => {
                        toggleSubmenu('paymentLinks');
                        history.push(`/products/paymentLinks?search=${data.document}`);
                    },
                },
                {
                    subMenu: t('paymentMovements.title'),
                    tabSubMenu: 'paymentMovements',
                    isSubMenuVisible: isPaymentMovementsVisible,
                    startIconSubMenu: isPaymentMovementsVisible ? <MovementsSVG customStroke="white" /> : <MovementsSVG />,
                    endIconSubMenu: <RightArrowSVG customStroke= {isPaymentMovementsVisible ? 'white' : getColor('secondary', '600')} />,
                    onClickSubMenu: () => {
                        toggleSubmenu('paymentMovements');
                        history.push(`/products/paymentMovements?search=${data.document}`);
                    },
                },
            ],
        },

        // TODO: Uncomment when cards product is enabled, was disabled at the request of BM-365
        // {
        //     menu: t('cards.title'),
        //     enabled: checkPermissions('show_clients.sub_cards'),
        //     startIconMenu: isCardsVisible && !isMovementsVisible && !isSummaryVisible && !isCollectionsVisible ? <CardsSVG customStroke='white' /> : <CardsSVG />,
        //     isVisible: isCardsVisible,
        //     tabSubMenu: 'cards',
        //     onClick: () => {
        //         toggleSubmenu('cards');
        //         history.push(`/clients/card/${clientId}`);
        //     },
        //     subMenus: [
        //         {
        //             subMenu: t('activity.title'),
        //             tabSubMenu: 'activity',
        //             startIconSubMenu: isMovementsVisible ? <MovementsSVG customStroke="white" /> : <MovementsSVG />,
        //             endIconSubMenu: <RightArrowSVG customStroke= {isMovementsVisible ? 'white' : getColor('primary', 'main')} />,
        //             onClickSubMenu: () => {
        //                 toggleSubmenu('activity');
        //                 if (!data?.document) return;
        //                 history.push(`/cards/movements?search=${data.document}`);
        //             }
        //         },
        //         {
        //             subMenu: t('summary.title'),
        //             tabSubMenu: 'summary',
        //             isSubMenuVisible: isSummaryVisible,
        //             startIconSubMenu: isSummaryVisible ? <SummarySVG customStroke="white" /> : <SummarySVG />,
        //             endIconSubMenu: <RightArrowSVG customStroke= {isSummaryVisible ? 'white' : getColor('primary', 'main')} />,
        //             onClickSubMenu: () => {
        //                 toggleSubmenu('summary');
        //                 history.push(`/cards/summaries?search=${data.document}`);
        //             },
        //         },
        //         {
        //             subMenu: t('collections.title'),
        //             tabSubMenu: 'collections',
        //             isSubMenuVisible: isCollectionsVisible,
        //             startIconSubMenu: isCollectionsVisible ? <CollectionsSVG customStroke="white" /> : <CollectionsSVG />,
        //             endIconSubMenu: <RightArrowSVG customStroke= {isCollectionsVisible ? 'white' : getColor('primary', 'main')} />,
        //             onClickSubMenu: () => {
        //                 toggleSubmenu('collections');
        //                 if (!data?.document) return;
        //                 history.push(`/cards/collections?search=${data.document}`);
        //             }
        //         },
        //     ]
        // },

    ];

    React.useEffect(() => {
        if (!isAddressVisible && !isEmailVisible && !isTelephoneVisible && !isDeviceVisible) {
            toggleSubmenu('');
        }
        else {
            toggleSubmenu('details');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box>
            <Box display='flex' flexDirection='column' className='clientDropMenu_menu--box'>
                {// eslint-disable-next-line array-callback-return
                    tabsColumn.map(tab => {
                        const isSubmenuVisible = isSubMenuOpen === tab.tabSubMenu;
                        if (tab.enabled) {
                            return (
                                <Box
                                    key={tab.menu}
                                    display='flex'
                                    flexDirection='column'
                                    alignItems={'space-between'}
                                    gap='8px'
                                >
                                    <ButtonBase
                                        style={{ textTransform: 'none', display: 'flex', justifyContent: 'space-between', flexGrow: 1, padding: '8px 16px 8px 24px' }}
                                        width='200px'
                                        height='36px'
                                        className={tab.isVisible ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button'}
                                        onClick={() => { tab.onClick(); }}
                                        disabled={tab.disabled}
                                    >
                                        <Box display={'inline-flex'} alignItems={'center'} gap='8px'>
                                            {tab.startIconMenu}
                                            {tab.menu}
                                        </Box>
                                        {tab?.tabSubMenu ? (
                                            <ButtonBase onClick={() => toggleSubmenu(tab.tabSubMenu)} sx={{ zIndex: 10 }}>
                                                <VectorMenuSVG open={isSubmenuVisible } customStroke={ tab.isVisible ? 'white' : palette.secondary[600]} />
                                            </ButtonBase>

                                        ) : null}

                                    </ButtonBase>
                                    {isSubMenuOpen === tab?.tabSubMenu && (
                                        tab.subMenus.map(tab =>
                                            <Box
                                                key={tab.tabSubMenu}
                                                display="flex"
                                                alignItems="center"
                                                width="200px"
                                                height="36px"
                                                className={tab.isSubMenuVisible ? 'clientSideMenu_container--active' : 'clientSideMenu_container--inactive'}
                                            >
                                                <ButtonBase
                                                    style={{ padding: '8px 16px 8px 30px', textTransform: 'none', display: 'inline-flex', justifyContent: 'space-between', width: '100%' }}
                                                    onClick={() => { tab.onClickSubMenu(); }}
                                                    className={tab.isSubMenuVisible ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button'}
                                                >
                                                    <Box display={'inline-flex'} alignItems={'center'} gap='8px'>
                                                        {tab.startIconSubMenu}
                                                        {tab.subMenu}
                                                    </Box>
                                                    {tab.endIconSubMenu}
                                                </ButtonBase>
                                            </Box>

                                        )
                                    )}
                                </Box>
                            );
                        };
                    })}
            </Box>
        </Box>
    );
}
